import { ApiError } from '@/shared/lib/api';

export class SubscriptionApiError extends Error {
  readonly status: number;
  readonly slug: string | undefined;
  readonly cause: ApiError;

  constructor(cause: ApiError) {
    super(cause.message);
    this.name = 'SubscriptionApiError';
    this.status = cause.status;
    this.slug = cause.code;
    this.cause = cause;
  }
}

export function wrapSubscriptionError<T>(promise: Promise<T>): Promise<T> {
  return promise.catch((err) => {
    if (err instanceof ApiError) throw new SubscriptionApiError(err);
    throw err;
  });
}
